<form class="responsive-grid" [class.loading]="isLoading" *ngIf="model" #form="ngForm">
    <mat-form-field>
        <mat-label>{{ 'settings.linkedin-form.linkedinCompanyIdLabel' | translate }}</mat-label>
        <input
            matInput
            type="text"
            name="linkedinCompanyId"
            required
            maxLength="20"
            [(ngModel)]="model.linkedinCompanyId"
            (ngModelChange)="modelChange()"
            #linkedinCompanyId="ngModel"
        />
        <mat-hint>
            <div>
                {{ 'settings.linkedin-form.helpText' | translate }}&nbsp;
                <a href="{{ 'settings.linkedin-form.helpLink' | translate }}" target="_blank">{{
                    'settings.linkedin-form.helpLink' | translate
                }}</a>
            </div>
        </mat-hint>
        <mat-error *ngIf="linkedinCompanyId.invalid">{{ linkedinCompanyId.errors | formErrors }}</mat-error>
    </mat-form-field>

    @if (needsConfirmation) {
        <ui-banner variant="bulb">
            {{ 'settings.linkedin-form.verifyYourLinkedinCompanyId' | translate }}
        </ui-banner>

        <div class="align-items-center flex margin-top-2 margin-bottom-2">
            <a href="{{ linkedinCompanyLink }}" target="_blank">
                {{ 'settings.linkedin-form.verifyYourLinkedinCompanyId' | translate }}
                <mat-icon class="margin-left-1" svgIcon="openInNew"> </mat-icon>
            </a>
            <ui-button type="primary" class="margin-left-2" (click)="confirm()">{{ 'confirm' | translate }}</ui-button>
        </div>
    }

    @if (hasConfirmed) {
        <ui-banner variant="success" class="margin-bottom-2">{{
            'settings.linkedin-form.linkedinCompanyIdConfirmed' | translate
        }}</ui-banner>
    }
</form>
